import { ROUTE_CONSTANT } from "../routing/route-constants";
import { useParams } from "react-router-dom";
import { APP_NAVIGATION, FOOTER_LINKS, SUPPORT_LINKS } from "./constants";
import { availableLanguages } from "../i18nextInit";
import { useTranslation } from "react-i18next";
import {
  getLegalSimpliBaseURL,
  getPdfSimpliBaseURL,
  getResumeBuildBaseURL,
  getSignSimpliBaseURL,
} from "../services/api-constants";
import { currentDomain } from "./general-config";
import { DomainEnum } from "../services/enum/environment-enum";

export const PathHelper = (sectionName, isfunnelStepsComplete, isCoverLetterSection, isReviewSection) => {
  const { t } = useTranslation();
  let { locale } = useParams();
  if (locale === undefined) {
    locale = localStorage.getItem("i18nextLng") === "en" ? "" : localStorage.getItem("i18nextLng");
  }
  const setLocaleURL = (url) => {
    let verifiedLocale = "en";
    if (!!locale) {
      if (availableLanguages.indexOf(locale) > -1) {
        verifiedLocale = locale;
      }
    }
    return url.replace(":locale", verifiedLocale);
  };
  const setUrlTextForDifferentLocale = (url, navigation) => {
    let linkUrl = "";
    if (navigation === APP_NAVIGATION.CNTC) {
      linkUrl = url.replace(SUPPORT_LINKS.SUPPORT, t("footer_links.support"));
    } else if (navigation === APP_NAVIGATION.PRVY) {
      linkUrl = url
        .replace(FOOTER_LINKS.PRIVACY_POLICY, t("footer_links.privacy_policy"))
        .replace(SUPPORT_LINKS.SUPPORT, t("footer_links.support"));
    } else if (navigation === APP_NAVIGATION.TUSE) {
      linkUrl = url
        .replace(FOOTER_LINKS.TERMS_CONDITIONS, t("footer_links.terms_conditions"))
        .replace(SUPPORT_LINKS.SUPPORT, t("footer_links.support"));
    }
    return linkUrl;
  };

  let pathValue = {
    back: ROUTE_CONSTANT.HOME,
    next: ROUTE_CONSTANT.HOME,
    cstm: ROUTE_CONSTANT.ROOT_HOME,
  };
  if (isfunnelStepsComplete && !isCoverLetterSection) {
    pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.REVIEW_LOCALE) : ROUTE_CONSTANT.REVIEW;
    pathValue.back = !!locale ? setLocaleURL(ROUTE_CONSTANT.REVIEW_LOCALE) : ROUTE_CONSTANT.REVIEW;
  } else {
    let verifiedLocale = "en";
    switch (sectionName) {
      case APP_NAVIGATION.RHOM:
        if (!!locale) {
          if (availableLanguages.indexOf(locale) > -1) {
            verifiedLocale = locale;
          }
        }
        pathValue.next =
          verifiedLocale !== "en" ? setLocaleURL(ROUTE_CONSTANT.ROOT_HOME_LOCALE) : ROUTE_CONSTANT.ROOT_HOME;
        break;
      case APP_NAVIGATION.HOME:
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_LOCALE) : ROUTE_CONSTANT.ROOT;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_LOCALE) : ROUTE_CONSTANT.ROOT;
        break;

      case APP_NAVIGATION.CONF:
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.RESUMES_LOCALE) : ROUTE_CONSTANT.RESUMES;
        pathValue.back = !!locale ? setLocaleURL(ROUTE_CONSTANT.REVIEW_LOCALE) : ROUTE_CONSTANT.REVIEW;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.HOME_LOCALE) : ROUTE_CONSTANT.HOME;
        break;
      case APP_NAVIGATION.DASH:
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.DASHBOARD_TRANSFER_LOCALE)
          : ROUTE_CONSTANT.DASHBOARD_TRANSFER;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_HOME_LOCALE) : ROUTE_CONSTANT.ROOT_HOME;
        break;
      case APP_NAVIGATION.FAQ:
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.PS_FAQ_LOCALE) : ROUTE_CONSTANT.PS_FAQ;
        break;
      case APP_NAVIGATION.PSCNTC:
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.PS_CONTACT__EFLOW_LOCALE)
          : ROUTE_CONSTANT.PS_CONTACT_EFLOW;
        break;
      case APP_NAVIGATION.SINI:
        pathValue.back = !!locale ? setLocaleURL(ROUTE_CONSTANT.HOME_LOCALE) : ROUTE_CONSTANT.HOME;
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.DASHBOARD_TRANSFER_LOCALE)
          : ROUTE_CONSTANT.DASHBOARD_TRANSFER;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_HOME_LOCALE) : ROUTE_CONSTANT.ROOT_HOME;
        break;
      case APP_NAVIGATION.SINU:
        pathValue.back = !!locale ? setLocaleURL(ROUTE_CONSTANT.HOME_LOCALE) : ROUTE_CONSTANT.HOME;
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.DASHBOARD_TRANSFER_LOCALE)
          : ROUTE_CONSTANT.DASHBOARD_TRANSFER;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_HOME_LOCALE) : ROUTE_CONSTANT.ROOT_HOME;
        break;
      case APP_NAVIGATION.CHPG:
        pathValue.back = !!locale ? setLocaleURL(ROUTE_CONSTANT.PLANS_LOCALE) : ROUTE_CONSTANT.PLANS;
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.CONFIRMATION_LOCALE) : ROUTE_CONSTANT.CONFIRMATION;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.RESUMES_LOCALE) : ROUTE_CONSTANT.RESUMES;
        break;
      case APP_NAVIGATION.PLAN:
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.CHECKOUT_LOCALE) : ROUTE_CONSTANT.CHECKOUT;
        break;
      case APP_NAVIGATION.EFLOW:
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.EFLOW_SALE_PAGE_LOCALE)
          : ROUTE_CONSTANT.EFLOW_SALE_PAGE;
        break;
      case APP_NAVIGATION.PRVY:
        if (!!locale) {
          if (availableLanguages.indexOf(locale) > -1) {
            verifiedLocale = locale;
          }
        }
        pathValue.cstm = setUrlTextForDifferentLocale(PrivacyPolicyLink(locale), APP_NAVIGATION.PRVY);
        break;
      case APP_NAVIGATION.CNTC:
        if (!!locale) {
          if (availableLanguages.indexOf(locale) > -1) {
            verifiedLocale = locale;
          }
        }
        pathValue.cstm = setUrlTextForDifferentLocale(ContactUsLink(locale), APP_NAVIGATION.CNTC);

        break;
      case APP_NAVIGATION.TUSE:
        if (!!locale) {
          if (availableLanguages.indexOf(locale) > -1) {
            verifiedLocale = locale;
          }
        }
        pathValue.cstm = setUrlTextForDifferentLocale(TermsAndConditionLink(locale), APP_NAVIGATION.TUSE);
        break;
      case APP_NAVIGATION.ADLG:
        pathValue.next = !!locale
          ? setLocaleURL(ROUTE_CONSTANT.DASHBOARD_TRANSFER_LOCALE)
          : ROUTE_CONSTANT.DASHBOARD_TRANSFER;
        break;
      default:
        pathValue.next = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_LOCALE) : ROUTE_CONSTANT.ROOT;
        pathValue.cstm = !!locale ? setLocaleURL(ROUTE_CONSTANT.ROOT_LOCALE) : ROUTE_CONSTANT.ROOT;
    }
  }
  return pathValue;
};

export const ContactUsLink = (locale) => {
  switch (currentDomain()) {
    case DomainEnum.RESUMEBUILD:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_CONTACT_LOCALE, ROUTE_CONSTANT.RS_CONTACT);
    case DomainEnum.PDFSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.PS_CONTACT_LOCALE, ROUTE_CONSTANT.PS_CONTACT);
    case DomainEnum.SIGNSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SS_CONTACT_LOCALE, ROUTE_CONSTANT.SS_CONTACT);
    case DomainEnum.LEGALSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.LS_CONTACT_LOCALE, ROUTE_CONSTANT.LS_CONTACT);
    case DomainEnum.WORKSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.WS_CONTACT_LOCALE, ROUTE_CONSTANT.WS_CONTACT);
    default:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_CONTACT_LOCALE, ROUTE_CONSTANT.RS_CONTACT);
  }
};

export const PrivacyPolicyLink = (locale) => {
  switch (currentDomain()) {
    case DomainEnum.RESUMEBUILD:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_POLICY_LOCALE, ROUTE_CONSTANT.RS_POLICY);
    case DomainEnum.PDFSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.PS_POLICY_LOCALE, ROUTE_CONSTANT.PS_POLICY);
    case DomainEnum.SIGNSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SS_POLICY_LOCALE, ROUTE_CONSTANT.SS_POLICY);
    case DomainEnum.LEGALSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.LS_POLICY_LOCALE, ROUTE_CONSTANT.LS_POLICY);
    case DomainEnum.WORKSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.WS_POLICY_LOCALE, ROUTE_CONSTANT.WS_POLICY);
    default:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_POLICY_LOCALE, ROUTE_CONSTANT.RS_POLICY);
  }
};
const RouteBasedOnLocale = (locale, localeRoute, withoutLocaleRoute) => {
  if (!!locale) {
    let verifiedLocale = "";
    if (availableLanguages.indexOf(locale) > -1) {
      verifiedLocale = locale;
    }
    return localeRoute.replace(":locale", verifiedLocale);
  } else {
    return withoutLocaleRoute;
  }
};
export const TermsAndConditionLink = (locale) => {
  switch (currentDomain()) {
    case DomainEnum.RESUMEBUILD:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_TERMS_LOCALE, ROUTE_CONSTANT.RS_TERMS);
    case DomainEnum.PDFSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.PS_TERMS_LOCALE, ROUTE_CONSTANT.PS_TERMS);
    case DomainEnum.SIGNSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SS_TERMS_LOCALE, ROUTE_CONSTANT.SS_TERMS);
    case DomainEnum.LEGALSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.LS_TERMS_LOCALE, ROUTE_CONSTANT.LS_TERMS);
    case DomainEnum.WORKSIMPLI:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.WS_TERMS_LOCALE, ROUTE_CONSTANT.WS_TERMS);
    default:
      return RouteBasedOnLocale(locale, ROUTE_CONSTANT.RS_TERMS_LOCALE, ROUTE_CONSTANT.RS_TERMS);
  }
};

export const getSignInLink = (locale, querystring) => {
  if (!!querystring)
    return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNIN_LOCALE, ROUTE_CONSTANT.SIGNIN) + querystring;
  else {
    return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNIN_LOCALE, ROUTE_CONSTANT.SIGNIN);
  }
};

export const getCoverLetterSignInLink = (locale) => {
  return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNIN_LOCALE, ROUTE_CONSTANT.SIGNIN);
};

export const getSignUpLink = (locale, querystring) => {
  if (!!querystring) {
    return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNUP_LOCALE, ROUTE_CONSTANT.SIGNUP) + querystring;
  } else {
    return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNUP_LOCALE, ROUTE_CONSTANT.SIGNUP);
  }
};

export const getCoverLetterSignUpLink = (locale) => {
  return RouteBasedOnLocale(locale, ROUTE_CONSTANT.SIGNUP_LOCALE, ROUTE_CONSTANT.SIGNUP);
};

export const getForgetPasswordLink = (locale) => {
  return RouteBasedOnLocale(locale, ROUTE_CONSTANT.FORGOT_PASSWORD_LOCALE, ROUTE_CONSTANT.FORGOT_PASSWORD);
};

export const getDashboardLinkWithLocale = (locale) => {
  if (currentDomain() === DomainEnum.RESUMEBUILD) {
    let url = getResumeBuildBaseURL + "/app" + getLinkWithLocale(locale, "dashboard");
    return url;
  } else {
    let url = getPdfSimpliBaseURL + "/app" + getLinkWithLocale(locale, "dashboard");
    return url;
  }
};

export const redirectToDashboardWithLocale = (locale) => {
  let url = "";
  // let localeVal = "";
  // if (!!locale) {
  //   localeVal = locale;
  // }
  url = getResumeBuildBaseURL;
  if (currentDomain() === DomainEnum.RESUMEBUILD) {
    url = getResumeBuildBaseURL;
  } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
    url = getSignSimpliBaseURL;
  } else if (currentDomain() === DomainEnum.LEGALSIMPLI) {
    url = getLegalSimpliBaseURL;
  } else {
    url = getPdfSimpliBaseURL;
  }
  window.location.href = url + "/app" + (!locale ? "" : "/" + locale) + "/dashboard";
};

export const getLinkWithLocale = (locale, endPoint) => {
  return (!locale ? "" : "/" + locale) + "/" + endPoint;
};
export default PathHelper;
